import { render, staticRenderFns } from "./WhatsAppBot.vue?vue&type=template&id=2ce17556"
import script from "./WhatsAppBot.vue?vue&type=script&lang=js"
export * from "./WhatsAppBot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports